
    import * as React from 'react';

    const NotificationEmpty16 = ({ color = 'currentcolor', height = '16px', width = '16px', ...rest }) => {
      const svgStyle: React.CSSProperties = {...{"position":"absolute","top":"0","right":"0","bottom":"0","left":"0","width":"100%","height":"100%"}, fill: color};

      return (
        <div style={{ ...{"position":"relative"}, height, width }} { ...rest }>
          <svg viewBox="0 0 16 16" style={svgStyle}><path d="M2 2h12v12H2V2zm.75.75v10.5h10.5V2.75H2.75z" /><path d="M8 3.757L12.243 8 8 12.243 3.757 8 8 3.757zm0 1.061L4.818 8 8 11.182 11.182 8 8 4.818z" /></svg>
        </div>
      );
    };

    NotificationEmpty16.displayName = 'NotificationEmpty16';

    export default NotificationEmpty16;
  